import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../../Config/AxiosInstance";
import APILIST from "../../../Config/ApiList";

export const ADD_SIGN_CONTRACTS_ACTION = createAsyncThunk('/content/add-contracts', async ({formData}) => {
  try {
    const response = await AxiosInstance.post(APILIST.ADD_SIGN_CONTRACTS, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
export const UPDATE_SIGN_CONTRACTS_ACTION = createAsyncThunk('/content/update-contracts', async ({formData, agreementId}) => {
  try {
    const response = await AxiosInstance.post(`${APILIST.UPDATE_SIGN_CONTRACTS}/${agreementId}`, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
export const GET_SIGN_CONTRACTS_ACTION = createAsyncThunk('/content/get-contracts', async () => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_SIGN_CONTRACTS + `?from=agreement`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
})
